import { create } from 'zustand';
import apiClient from './api/apiClient';

const useNotificationStore = create((set) => ({
  notification: { text: '' },

  fetchNotification: async () => {
    try {
      const data = await apiClient.get('/admin/notification');
      set({ notification: data.notification });
    } catch (error) {
      console.error('Failed to fetch notification:', error);
    }
  },

  updateNotification: async (notificationData) => {
    try {
      const data = await apiClient.patch('/admin/notification', notificationData);
      set({ notification: data.notification });
      return data.notification;
    } catch (error) {
      console.error('Failed to update notification:', error);
      throw error;
    }
  },
}));

export default useNotificationStore;
